<template>
  <el-dialog v-model="dialogVisible" title="" width="640px" :show-close="false" :close-on-click-modal="false" modal-class="patient-variable-dialog" append-to-body @close="closeDialog">
    <!-- Header -->
    <template #header>
      <div class="pv-header">
        <div class="pv-header-left">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
              fill="#004879"
            />
          </svg>
          <span class="pv-header-title">Variables Properties</span>
        </div>
        <button class="pv-close-btn" @click="closeDialog">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="#333" />
          </svg>
        </button>
      </div>
    </template>

    <!-- Tabs -->
    <div class="pv-body">
      <div class="pv-tabs">
        <div
          v-for="(variable, index) in ptVariables"
          :key="variable"
          class="pv-tab"
          :class="{ active: activeTabIndex === index }"
          @click.stop="activeTabIndex = index"
        >
          <div class="pv-tab-icon" v-html="getSvg(variable)"></div>
          <span class="pv-tab-label">{{ getVariableLabel(variable) }}</span>
        </div>
      </div>

      <!-- Tab Content -->
      <div v-loading="isLoading" class="pv-content">
        <!-- Variables Section -->
        <div class="pv-section">
          <p class="pv-section-title">Variables:</p>
          <div class="pv-variable-row">
            <span class="pv-variable-name">{{ getVariableLabel(activeVariable) }}</span>
            <span class="pv-variable-code">[[{{ activeVariable }}]]</span>
          </div>
          <div v-if="activeVariableData.current_value" class="pv-variable-row">
            <span class="pv-variable-name">Current Value</span>
            <span class="pv-variable-value-text">{{ activeVariableData.current_value }}</span>
          </div>
        </div>

        <!-- Active Source Section -->
        <div class="pv-section">
          <p class="pv-section-title">Active Source:</p>
          <div class="pv-source-list">
            <div v-for="source in activeSourceList" :key="source.name" class="pv-source-item">
              <div class="pv-source-icon" :style="{ backgroundColor: '#e5f9ef' }">
                <span v-html="source.icon"></span>
              </div>
              <div class="pv-source-info">
                <span class="pv-source-name">{{ source.name }}</span>
                <span class="pv-source-desc">{{ source.description }}</span>
              </div>
              <div class="pv-active-badge">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M3.09167 6.88333L3.79167 6.18333C3.20833 5.6 2.91667 4.84167 2.91667 4.14167C2.91667 3.38333 3.20833 2.625 3.79167 2.1L3.09167 1.4C2.33333 2.15833 1.925 3.15 1.925 4.14167C1.925 5.13333 2.33333 6.125 3.09167 6.88333Z"
                    fill="#20A8C3"
                  />
                  <path
                    d="M9.975 0L9.275 0.7C10.2083 1.63333 10.675 2.91667 10.675 4.14167C10.675 5.36667 10.2083 6.65 9.275 7.58333L9.975 8.28333C11.1417 7.11667 11.6667 5.65833 11.6667 4.14167C11.6667 2.625 11.0833 1.16667 9.975 0Z"
                    fill="#20A8C3"
                  />
                  <path
                    d="M2.39167 0.7L1.69167 0C0.583333 1.16667 0 2.625 0 4.14167C0 5.65833 0.583333 7.11667 1.69167 8.28333L2.39167 7.58333C1.45833 6.65 0.991667 5.36667 0.991667 4.14167C0.991667 2.91667 1.45833 1.63333 2.39167 0.7Z"
                    fill="#20A8C3"
                  />
                  <path
                    d="M8.575 6.88333C9.33333 6.125 9.74167 5.13333 9.74167 4.14167C9.68333 3.15 9.33333 2.15833 8.575 1.4L7.875 2.1C8.45833 2.68333 8.75 3.44167 8.75 4.14167C8.75 4.9 8.45833 5.65833 7.875 6.18333L8.575 6.88333Z"
                    fill="#20A8C3"
                  />
                  <path
                    d="M7.29167 4.14167C7.29167 3.33667 6.63833 2.68333 5.83333 2.68333C5.02833 2.68333 4.375 3.33667 4.375 4.14167C4.375 4.585 4.57333 4.97 4.8825 5.23833L2.91667 11.1417H4.08333L4.47417 9.975H7.19833L7.58333 11.1417H8.75L6.78417 5.23833C7.09333 4.97 7.29167 4.585 7.29167 4.14167ZM4.85917 8.80833L5.83333 5.89167L6.8075 8.80833H4.85917Z"
                    fill="#20A8C3"
                  />
                </svg>
                <span>Active</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Value History Section -->
        <div class="pv-section">
          <p class="pv-section-title">Value History</p>
          <div v-if="activeHistoryList.length" class="pv-history-table">
            <div v-for="(entry, idx) in activeHistoryList" :key="idx" class="pv-history-row">
              <span class="pv-history-date">{{ entry.date }}</span>
              <span class="pv-history-value">{{ entry.new_value }}</span>
              <div class="pv-history-source-badge">
                <span class="pv-history-source-icon" v-html="getSourceIcon(entry.source_type)"></span>
                <span>{{ getSourceLabel(entry.source_type) }}</span>
              </div>
              <!-- <span class="pv-history-author">{{ entry.source_id }}</span> -->
            </div>
          </div>
          <div v-else class="pv-history-empty">No history available</div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <template #footer>
      <div class="pv-footer">
        <VAButton color-type="sky-blue-stroke" @click="closeDialog">Close</VAButton>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import ptVariableSvgMap from '@/utils/ptVariableSvgMap';
import request from '@/views/setting/my-practice/service/request.js';

const store = useStore();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  ptVariables: {
    type: Array,
    default: () => [],
  },
  patientId: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:visible', 'reset']);

const dialogVisible = ref(false);

watch(() => props.visible, (val) => {
  dialogVisible.value = val;
});

const activeTabIndex = ref(0);
const variableData = ref({});
const isLoading = ref(false);

const activeVariable = computed(() => {
  return props.ptVariables[activeTabIndex.value] || '';
});

const labelMap = {
  pt_phone: 'Phone',
  pt_email: 'Email',
  pt_address: 'Address',
  pt_sex: 'Sex',
  pt_gender: 'Gender Identity',
  pt_age: 'Patient Age',
  pt_dob: 'DOB',
  pt_height: 'Height',
  pt_weight: 'Weight',
  pt_bmi: 'BMI',
  pt_cdc_growth_percentile: 'CDC Growth Percentile',
  pt_pulse: 'Pulse',
  pt_bp: 'BP',
  pt_bp_raw: 'BP (Raw)',
  pt_rxs: 'Active Rx',
  pt_rxs_w_date: 'Active Rx (Date)',
  pt_meds: 'Med Details',
  pt_allergies: 'Allergies',
};

const getVariableLabel = (key) => {
  return labelMap[key] || key.replace('pt_', '').replace(/_/g, ' ');
};

const getSvg = (key) => {
  return ptVariableSvgMap[key] || '';
};

const getSourceIcon = (sourceType) => {
  const icon = sourceTypeConfig[sourceType]?.icon || '';
  // Replace fill color for history badge icons
  return icon.replace(/#20A8C3/g, '#374957');
};

const getSourceLabel = (sourceType) => {
  const labels = { system: 'System', manual: 'Manual', form: 'Form', encounter: 'Notes', integration: 'Integration' };
  return labels[sourceType] || sourceType;
};

const closeDialog = () => {
  dialogVisible.value = false;
  emit('update:visible', false);
};

// Fetch variable data from API when dialog opens
const fetchVariableData = async (key) => {
  if (!props.patientId || !key) return;
  isLoading.value = true;
  try {
    const response = await request.get(`/patientvariable/patients/${props.patientId}/variables/${key}`);
    variableData.value[key] = response.data;
  } catch (error) {
    console.error(`Failed to fetch variable ${key}:`, error);
  } finally {
    isLoading.value = false;
  }
};

// Fetch active sources for a variable key
const activeSourcesData = ref({});

const fetchActiveSources = async (key) => {
  const clinicId = store.state.login?.userInfo?.clinic_id;
  if (!clinicId || !key) return;
  try {
    const response = await request.get('/patientvariable/active-sources', {
      params: { clinic_id: clinicId, patient_variable_key: key }
    });
    activeSourcesData.value[key] = response.data?.sources || [];
  } catch (error) {
    console.error(`Failed to fetch active sources for ${key}:`, error);
  }
};

// Fetch data for all variables when dialog opens
watch(dialogVisible, (visible) => {
  if (visible && props.patientId) {
    activeTabIndex.value = 0;
    props.ptVariables.forEach((key) => {
      fetchVariableData(key);
      fetchActiveSources(key);
    });
  }
});

// Refetch when switching tabs if data not yet loaded
watch(activeTabIndex, (idx) => {
  const key = props.ptVariables[idx];
  if (key) {
    if (!variableData.value[key]) fetchVariableData(key);
    if (!activeSourcesData.value[key]) fetchActiveSources(key);
  }
});

const activeVariableData = computed(() => {
  return variableData.value[activeVariable.value] || {};
});

const sourceTypeConfig = {
  manual: {
    name: 'Manual Data Entry',
    description: 'Provider override via panel',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none"><path d="M16 16L10.6667 21.3333H24V16H16Z" fill="#20A8C3"/><path d="M12.08 4.25333L0 16.3333V21.3333H5L17.08 9.25333L12.08 4.25333ZM3.89333 18.6667H2.66667V17.44L12.08 8.02667L13.3067 9.25333L3.89333 18.6667Z" fill="#20A8C3"/><path d="M20.9467 5.38667C21.4667 4.86667 21.4667 4.02667 20.9467 3.50667L17.8267 0.386667C17.56 0.12 17.2267 0 16.88 0C16.5467 0 16.2 0.133333 15.9467 0.386667L13.5067 2.82667L18.5067 7.82667L20.9467 5.38667Z" fill="#20A8C3"/></svg>',
  },
  form: {
    name: 'Patient Intake Form',
    description: 'Mapped to field in form.',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 18 23" fill="none"><path d="M4.5 12.5053H13.5V10.2316H4.5V12.5053ZM4.5 15.9158H13.5V13.6421H4.5V15.9158ZM4.5 19.3263H10.125V17.0526H4.5V19.3263ZM2.25 22.7368C1.63125 22.7368 1.10156 22.5142 0.660938 22.0689C0.220313 21.6237 0 21.0884 0 20.4632V2.27368C0 1.64842 0.220313 1.11316 0.660938 0.667895C1.10156 0.222632 1.63125 0 2.25 0H11.25L18 6.82105V20.4632C18 21.0884 17.7797 21.6237 17.3391 22.0689C16.8984 22.5142 16.3688 22.7368 15.75 22.7368H2.25ZM10.125 7.95789V2.27368H2.25V20.4632H15.75V7.95789H10.125Z" fill="#20A8C3"/></svg>',
  },
  system: {
    name: 'System Calculation',
    description: 'Automatically calculated by system.',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M17.7778 0H2.22222C1 0 0 1 0 2.22222V17.7778C0 19 1 20 2.22222 20H17.7778C19 20 20 19 20 17.7778V2.22222C20 1 19 0 17.7778 0ZM17.7778 17.7778H2.22222V2.22222H17.7778V17.7778Z" fill="#20A8C3"/><path d="M9.16667 5.24444H3.61111V6.91111H9.16667V5.24444Z" fill="#20A8C3"/><path d="M16.6667 14.1667H11.1111V15.8333H16.6667V14.1667Z" fill="#20A8C3"/><path d="M16.6667 11.3889H11.1111V13.0556H16.6667V11.3889Z" fill="#20A8C3"/><path d="M5.55556 16.6667H7.22222V14.4444H9.44444V12.7778H7.22222V10.5556H5.55556V12.7778H3.33333V14.4444H5.55556V16.6667Z" fill="#20A8C3"/><path d="M12.3222 8.83333L13.8889 7.26667L15.4556 8.83333L16.6333 7.65556L15.0667 6.07778L16.6333 4.51111L15.4556 3.33333L13.8889 4.9L12.3222 3.33333L11.1444 4.51111L12.7111 6.07778L11.1444 7.65556L12.3222 8.83333Z" fill="#20A8C3"/></svg>',
  },
  encounter: {
    name: 'Signed Encounter Notes',
    description: 'Auto-extracted from vitals sections',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none"><path d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM2 18H14V2H12V9L9.5 7.5L7 9V2H2V18Z" fill="#20A8C3"/></svg>',
  },
  integration: {
    name: 'External Integration',
    description: 'Synced from external system',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z" fill="#20A8C3"/></svg>',
  },
};

const resolveSourceConfig = (type) => {
  // Exact match
  if (sourceTypeConfig[type]) return sourceTypeConfig[type];
  // Fuzzy match: use matched icon but keep original name
  const lower = (type || '').toLowerCase();
  let matched = null;
  if (lower.includes('form')) matched = sourceTypeConfig.form;
  else if (lower.includes('manual')) matched = sourceTypeConfig.manual;
  else if (lower.includes('system') || lower.includes('calculat')) matched = sourceTypeConfig.system;
  else if (lower.includes('encounter') || lower.includes('note')) matched = sourceTypeConfig.encounter;
  else if (lower.includes('integrat') || lower.includes('external')) matched = sourceTypeConfig.integration;
  if (matched) return { ...matched, name: type };
  return { name: type, description: '', icon: '' };
};

// Active sources from API, with fallback to showing all
const activeSourceList = computed(() => {
  const sources = activeSourcesData.value[activeVariable.value];
  if (sources && sources.length) {
    return sources.map(type => {
      const config = resolveSourceConfig(type);
      return { ...config, isActive: true };
    });
  }
  // Fallback: show all source types if API hasn't responded yet
  return Object.values(sourceTypeConfig);
});

const formatDate = (timestamp) => {
  if (!timestamp) return '';
  const d = new Date(timestamp);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[d.getMonth()]}-${String(d.getDate()).padStart(2, '0')}-${d.getFullYear()}`;
};

const activeHistoryList = computed(() => {
  const data = activeVariableData.value;
  if (!data?.events?.length) return [];
  return data.events.map(event => ({
    ...event,
    date: formatDate(event.timestamp),
  }));
});
</script>

<style scoped>
/* Header */
.pv-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
}

.pv-header-left {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pv-header-title {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #004879;
}

.pv-close-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  width: 28px;
  height: 28px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Body */
.pv-body {
  display: flex;
  flex-direction: column;
  background: #f9fbfd;
  padding: 0 24px;
}

/* Tabs */
.pv-tabs {
  display: flex;
  padding: 8px 8px 0 8px;
  border-bottom: 1px solid #e6e6e6;
}

.pv-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 16px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  background: white;
}

.pv-tab.active {
  border-bottom-color: #004879;
}

.pv-tab.active .pv-tab-label {
  color: #004879;
}

.pv-tab-icon {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pv-tab-icon :deep(svg) {
  width: 18px;
  height: 18px;
}

.pv-tab-label {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #666;
  letter-spacing: 0.1px;
  white-space: nowrap;
}

/* Content */
.pv-content {
  background: white;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  max-height: 500px;
}

/* Sections */
.pv-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pv-section-title {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #333;
  letter-spacing: 0.15px;
  margin: 0;
}

/* Variable Row */
.pv-variable-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  height: 20px;
}

.pv-variable-name {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333;
  letter-spacing: 0.1px;
}

.pv-variable-code {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #004879;
  letter-spacing: 0.25px;
  text-decoration: underline;
}

.pv-variable-value-text {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333;
  letter-spacing: 0.25px;
}

.pv-history-empty {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #666;
  text-align: center;
  padding: 16px;
}

/* Source List */
.pv-source-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pv-source-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: white;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
}

.pv-source-icon {
  width: 32px;
  height: 32px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pv-source-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.pv-source-name {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #374957;
  letter-spacing: 0.1px;
}

.pv-source-desc {
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  color: #666;
  letter-spacing: 0.25px;
}

.pv-active-badge {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 6px;
  background: #e5f9ef;
  border-radius: 10px;
  flex-shrink: 0;
}

.pv-active-badge span {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #20a8c3;
  letter-spacing: 0.4px;
}

/* History Table */
.pv-history-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  padding: 12px 8px;
}

.pv-history-row {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
}

.pv-history-row + .pv-history-row {
  border-top: 1px dashed #c4c4c4;
  padding-top: 12px;
}

.pv-history-date {
  width: 98px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #333;
  letter-spacing: 0.4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
}

.pv-history-value {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #333;
  text-align: center;
  letter-spacing: 0.4px;
}

.pv-history-source-badge {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 8px;
  background: #f2f2f2;
  border-radius: 20px;
  flex-shrink: 0;
  width: 100px;
  justify-content: center;
}

.pv-history-source-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.pv-history-source-icon :deep(svg) {
  width: 16px;
  height: 16px;
}

.pv-history-source-badge span {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #333;
  letter-spacing: 0.4px;
  white-space: nowrap;
}

.pv-history-author {
  width: 72px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #666;
  text-align: center;
  letter-spacing: 0.4px;
  flex-shrink: 0;
}

/* Footer */
.pv-footer {
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 24px;
  border-top: 1px dashed #c4c4c4;
  background: #f9fbfd;
}

.pv-reset-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 2px;
}

.pv-reset-btn span {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #d10000;
  text-decoration: underline;
  letter-spacing: 0.1px;
}

.pv-close-footer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 32px;
  height: 32px;
  background: white;
  border: 1px solid #1e4670;
  border-radius: 4px;
  box-shadow: 0px 1px 3px rgba(74, 74, 74, 0.25);
  cursor: pointer;
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #1e4670;
  letter-spacing: 0.1px;
}
</style>

<style>
/* Unscoped overrides for el-dialog */
.patient-variable-dialog .el-dialog {
  border-radius: 10px !important;
  overflow: hidden;
  --el-dialog-padding-primary: 0px !important;
}

.patient-variable-dialog .el-dialog__header {
  padding: 0 !important;
  margin: 0 !important;
  margin-right: 0 !important;
  background: #f9fbfd;
}

.patient-variable-dialog .el-dialog__body {
  padding: 0 !important;
}

.patient-variable-dialog .el-dialog__footer {
  padding: 0 !important;
}

.patient-variable-dialog .el-dialog__headerbtn {
  display: none;
}
</style>
